// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-email label { font-size: 16px; margin-right: 20px;}

/* tooltip.css */
.custom-tooltip {
    z-index: 1000 !important; 
    
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pages/segments/segments-management/publishers/Publishers.css"],"names":[],"mappings":"AAAA,oBAAoB,eAAe,EAAE,kBAAkB,CAAC;;AAExD,gBAAgB;AAChB;IACI,wBAAwB;;EAE1B","sourcesContent":[".send-email label { font-size: 16px; margin-right: 20px;}\n\n/* tooltip.css */\n.custom-tooltip {\n    z-index: 1000 !important; \n    \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
